module.exports = __webpack_public_path__ + "img/giftcards-desktop.962f69fc.jpg";